<template>
  <div>
    <b-table striped hover :items="prestazioneScelta" :fields="fields" responsive stacked="lg">
      <template v-slot:cell(dataEora)="row">
        <label>{{ row.item.dataAppuntamento }}</label>
      </template>
      <template v-slot:cell(importo)="row">
        <span>{{ row.item.importo }} €</span>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  props: {
    prestazioneScelta: Array,
  },
  data() {
    return {
      fields: [
        {
          label: "codice Prestazione",
          key: "codCatalogo",
        },
        {
          label: "codice Ambulatorio",
          key: "idAmbulatorio",
        },
        {
          label: "Descrizione Struttura",
          key: "desStruttura",
        },
        {
          label: "Destinazione Ambulatorio",
          key: "desAmbulatorio",
        },
        {
          label: "Data Appuntamento",
          key: "dataAppuntamento",
        },
        {
          label: "importo",
          key: "importo",
        },
      ],
    };
  },
};
</script>
